export default {"src":"/_next/static/media/Demyst.5001eb93.svg","height":22,"width":16};